module.exports = __webpack_public_path__ + "img/moi_coeur_2.c8995030.jpg";